module.exports = __webpack_public_path__ + "img/penalty.4d3e9617.svg";